<template>
  <div>
    <!-- 使用公共导航栏组件 -->
    <Nav />

    <!-- 主要内容区 - 会员中心左右结构 -->
    <div class="flex pt-20 max-w-7xl mx-auto">
      <LeftNav activeItem="preorderadd" />
      <main class="flex-1 p-6">
        <div>
          <div class="mb-8">
            <h1 class="text-2xl font-bold text-gray-900">创建预订单</h1>
            <p class="text-gray-600 mt-1">创建预订单，生成后可以转发给客户</p>
          </div>
          <div class="space-y-6">
            <div class="flex gap-6 mb-6">
              <!-- 活动信息 -->
              <div
                class="w-[50%] bg-white rounded-xl shadow-sm border border-gray-100 p-6"
              >
                <h2 class="text-xl font-bold text-gray-900 mb-6">活动信息</h2>
                <form class="space-y-6">
                  <div class="grid grid-cols-2 gap-4">
                    <div class="col-span-2">
                      <label class="block text-sm font-medium text-gray-700 mb-2"
                        >活动名称 <span class="text-red-500">*</span></label
                      >
                      <input
                        type="text"
                        name="activity_name"
                        v-model="activityName"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
                        placeholder="请输入活动名称"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-2"
                        >活动类型 <span class="text-red-500">*</span></label
                      >
                      <div class="relative">
                        <button
                          type="button"
                          class="activity-type-select w-full px-3 py-2 border border-gray-300 rounded-lg text-sm text-left bg-white flex items-center justify-between cursor-pointer"
                          @click.stop="toggleDropdown"
                        >
                          <span
                            :class="[
                              'selected-text',
                              selectedActivityType ? '' : 'text-gray-500',
                            ]"
                          >
                            {{ selectedActivityType || "请选择活动类型" }}
                          </span>
                          <div class="w-4 h-4 flex items-center justify-center">
                            <i class="ri-arrow-down-s-line text-gray-400"></i>
                          </div>
                        </button>
                        <div
                          v-show="dropdownVisible"
                          class="activity-type-dropdown absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-lg shadow-lg mt-1 z-10"
                        >
                          <div class="py-1">
                            <button
                              v-for="type in activityTypes"
                              :key="type"
                              type="button"
                              class="activity-type-option w-full px-3 py-2 text-left text-sm hover:bg-gray-50 cursor-pointer"
                              @click="selectActivityType(type)"
                            >
                              {{ type }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-2"
                        >预计人数 <span class="text-red-500">*</span></label
                      >
                      <div class="relative">
                        <button
                          type="button"
                          class="people-count-select w-full px-3 py-2 border border-gray-300 rounded-lg text-sm text-left bg-white flex items-center justify-between cursor-pointer"
                          @click.stop="togglePeopleDropdown"
                        >
                          <span
                            :class="[
                              'selected-text',
                              selectedPeopleCount ? '' : 'text-gray-500',
                            ]"
                          >
                            {{ selectedPeopleCount || "请选择预计人数" }}
                          </span>
                          <div class="w-4 h-4 flex items-center justify-center">
                            <i class="ri-arrow-down-s-line text-gray-400"></i>
                          </div>
                        </button>
                        <div
                          v-show="peopleDropdownVisible"
                          class="people-count-dropdown absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-lg shadow-lg mt-1 z-10"
                        >
                          <div class="py-1">
                            <button
                              v-for="count in peopleCounts"
                              :key="count"
                              type="button"
                              class="people-count-option w-full px-3 py-2 text-left text-sm hover:bg-gray-50 cursor-pointer"
                              @click="selectPeopleCount(count)"
                            >
                              {{ count }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-2"
                        >开始日期 <span class="text-red-500">*</span></label
                      >
                      <input
                        type="date"
                        name="start_date"
                        v-model="startDate"
                        :min="today"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
                        @change="onStartDateChange"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-2"
                        >结束日期 <span class="text-red-500">*</span></label
                      >
                      <input
                        type="date"
                        name="end_date"
                        v-model="endDate"
                        :min="startDate || today"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
                        @change="onEndDateChange"
                      />
                    </div>
                    <div class="col-span-2">
                      <label class="block text-sm font-medium text-gray-700 mb-2"
                        >活动地点 <span class="text-red-500">*</span></label
                      >
                      <input
                        type="text"
                        name="location"
                        v-model="location"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
                        placeholder="请输入活动地址"
                      />
                    </div>
                  </div>
                </form>
              </div>
              <!-- 收货信息 -->
              <div
                class="w-[50%] bg-white rounded-xl shadow-sm border border-gray-100 p-6"
              >
                <h2 class="text-xl font-bold text-gray-900 mb-6">收货信息</h2>
                <form class="space-y-6">
                  <div class="grid grid-cols-2 gap-4">
                    <div class="col-span-2">
                      <label class="block text-sm font-medium text-gray-700 mb-2"
                        >收货人姓名 <span class="text-red-500">*</span></label
                      >
                      <input
                        type="text"
                        name="recipient_name"
                        v-model="recipientName"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
                        placeholder="请输入收货人姓名，例如：张三或待定"
                      />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-2"
                        >收货人手机号 <span class="text-red-500">*</span></label
                      >
                      <input
                        type="text"
                        name="recipient_phone"
                        v-model="recipientPhone"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
                        placeholder="请输入收货人手机号，例如：13800000000或待定"
                      />
                    </div>

                    <div class="col-span-2">
                      <label class="block text-sm font-medium text-gray-700 mb-2"
                        >收货人详细地址 <span class="text-red-500">*</span></label
                      >
                      <input
                        type="text"
                        name="recipient_address"
                        v-model="recipientAddress"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
                        placeholder="请输入收货人详细地址，例如：北京市海淀区或待定"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <!-- 右侧已选租赁设备 -->
            <div class="flex-1 flex flex-col">
              <!-- 顶部已选租赁设备区域 -->
              <div class="bg-white border-b border-gray-200 p-6 rounded-xl">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="text-lg font-semibold text-gray-900">
                    已选租赁设备
                  </h3>
                  <button
                    class="add-item-btn text-gray-500 hover:text-primary transition-colors cursor-pointer flex items-center"
                    @click="showEquipmentSelector = true"
                  >
                    <div class="w-4 h-4 flex items-center justify-center mr-1">
                      <i class="ri-add-line"></i>
                    </div>
                    <span class="text-sm">添加租赁设备</span>
                  </button>
                </div>
                <div
                  v-if="selectedItems.length === 0"
                  class="empty-state text-center text-gray-400 py-8"
                >
                  <div
                    class="w-16 h-16 flex items-center justify-center mx-auto mb-3"
                  >
                    <i class="ri-shopping-cart-line text-3xl"></i>
                  </div>
                  <p class="text-sm">暂无选中的租赁设备</p>
                </div>
                <div v-else class="selected-items-list">
                  <!-- 按分类分组 -->
                  <div
                    v-for="(group, categoryName) in itemsByCategory"
                    :key="categoryName"
                    class="mb-6"
                  >
                    <div
                      class="bg-gray-50 p-2 pl-4 border-l-4 border-primary text-gray-700 font-medium text-sm mb-2"
                    >
                      分类: {{ categoryName }}
                    </div>

                    <div class="space-y-0 rounded-lg overflow-hidden">
                      <div
                        v-for="item in group"
                        :key="item.sku_id"
                        class="flex items-center justify-between p-4 border-b border-gray-100"
                      >
                        <div class="flex items-center flex-1">
                          <img
                            :src="item.thumbnail_url"
                            :alt="item.name"
                            class="w-12 h-12 object-cover object-top rounded-lg mr-3"
                          />
                          <div class="flex-1">
                            <h4 class="font-medium text-gray-900 text-sm">
                              {{ item.name }}
                            </h4>
                            <p class="text-xs text-gray-500">
                              {{ item.spec_text }}
                            </p>
                          </div>
                        </div>
                        <div class="flex items-center space-x-3">
                          <div class="flex items-center space-x-2">
                            <button
                              class="quantity-btn decrease w-6 h-6 bg-gray-100 rounded flex items-center justify-center text-gray-600 hover:bg-gray-200 cursor-pointer"
                              @click="updateItemQuantityBySku(item.sku_id, -1)"
                            >
                              <i class="ri-subtract-line text-xs"></i>
                            </button>
                            <span class="quantity text-sm font-medium">{{
                              item.quantity
                            }}</span>
                            <button
                              class="quantity-btn increase w-6 h-6 bg-gray-100 rounded flex items-center justify-center text-gray-600 hover:bg-gray-200 cursor-pointer"
                              @click="updateItemQuantityBySku(item.sku_id, 1)"
                            >
                              <i class="ri-add-line text-xs"></i>
                            </button>
                          </div>
                          <div class="text-md text-gray-500 whitespace-nowrap">
                            <span class="mx-2">×</span> ¥{{ item.price }}/天
                            <span class="mx-2">×</span> {{ rentalDays }}天
                            <span class="mx-2">=</span>
                          </div>
                          <span class="text-primary font-semibold text-md"
                            >¥{{
                              (item.price * item.quantity * rentalDays).toFixed(
                                2
                              )
                            }}</span
                          >
                          <button
                            class="remove-item w-6 h-6 flex items-center justify-center text-gray-400 hover:text-red-500 cursor-pointer"
                            @click="removeItemBySku(item.sku_id)"
                          >
                            <i class="ri-close-line text-sm"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="flex justify-end mt-4">
                      <button
                        class="text-xs text-gray-500 hover:text-red-500"
                        @click="removeAllByCategory(categoryName)"
                      >
                        清空该分类设备
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 底部总计和提交区域 -->
              <div
                class="bg-white border-t border-gray-200 p-6  rounded-xl mt-6"
              >
                <div class="flex items-center justify-between mb-4">
                  <span class="text-gray-600">租赁天数:</span>
                  <span class="text-gray-900 font-medium"
                    >{{ rentalDays }}天</span
                  >
                </div>
                <div class="flex items-center justify-between mb-4">
                  <span class="text-lg font-semibold text-gray-900">总计:</span>
                  <span class="total-amount text-2xl font-bold text-primary"
                    >¥{{ totalAmount.toFixed(2) }}</span
                  >
                </div>
                <button
                  class="submit-booking w-full bg-primary text-white py-3 !rounded-button hover:bg-secondary transition-colors text-base font-medium whitespace-nowrap cursor-pointer"
                  @click="submitBooking"
                >
                  提交预订单
                </button>
              </div>
            </div>
          </div>
          <!-- 租赁设备选择器组件 -->
          <GoodsSelector
            :visible="showEquipmentSelector"
            :on-close="handleCloseEquipmentSelector"
            :on-add-item="handleAddItem"
          />
        </div>
      </main>
    </div>

    <!-- 使用公共页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import GoodsSelector from "@/components/GoodsSelector.vue";
import LeftNav from "@/components/LeftNav.vue";
import api from "@/utils/api.js";

export default {
  name: "PreOrderAdd",
  components: {
    Nav,
    Footer,
    GoodsSelector,
    LeftNav,
  },
  data() {
    // 获取今天的日期，格式为YYYY-MM-DD
    const today = new Date().toISOString().split("T")[0];

    return {
      dropdownVisible: false,
      selectedActivityType: "",
      peopleDropdownVisible: false,
      selectedPeopleCount: "",
      activityTypes: [
        "展览会",
        "会议",
        "研讨会",
        "产品发布会",
        "企业年会",
        "培训活动",
      ],
      peopleCounts: ["10-30 人", "30-100 人", "100-300 人", "300+ 人"],
      showEquipmentSelector: false,
      selectedItems: [],
      startDate: "",
      endDate: "",
      location: "",
      activityName: "",
      today: today,
      recipientName: "",
      recipientPhone: "",
      recipientAddress: "",
    };
  },
  computed: {
    // 按分类分组的设备
    itemsByCategory() {
      const groups = {};
      this.selectedItems.forEach((item) => {
        // 获取分类名称，如果没有则使用"未分类"
        const categoryName = item.category_name || item.category || "未分类";
        if (!groups[categoryName]) {
          groups[categoryName] = [];
        }
        groups[categoryName].push(item);
      });
      return groups;
    },

    // 计算租赁天数
    rentalDays() {
      if (!this.startDate || !this.endDate) {
        return 0;
      }
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      // 计算两个日期之间的天数差
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 因为包含开始日期
      return diffDays;
    },

    // 计算预订单总金额（考虑天数）
    totalAmount() {
      return this.selectedItems.reduce((total, item) => {
        return total + item.price * item.quantity * this.rentalDays;
      }, 0);
    },
  },
  methods: {
    // 切换活动类型下拉菜单显示状态
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
      // 点击活动类型时关闭人数选择下拉菜单
      if (this.peopleDropdownVisible) {
        this.peopleDropdownVisible = false;
      }
    },

    // 开始日期变更处理
    onStartDateChange() {
      // 如果结束日期小于开始日期，则清空结束日期
      if (this.endDate && this.endDate < this.startDate) {
        this.endDate = "";
      }
    },

    // 结束日期变更处理
    onEndDateChange() {
      // 如果结束日期小于开始日期，则清空结束日期并提示
      if (this.endDate && this.startDate && this.endDate < this.startDate) {
        this.endDate = "";
        this.$message.warning("结束日期必须大于等于开始日期");
      }
    },

    // 加载缓存数据
    loadCachedData() {
      try {
        const preOrderData = JSON.parse(localStorage.getItem("preOrderData"));
        if (preOrderData) {
          // 恢复表单数据
          this.selectedActivityType = preOrderData.activityType || "";
          this.startDate = preOrderData.startDate || "";
          this.endDate = preOrderData.endDate || "";
          this.location = preOrderData.location || "";
          this.recipientName = preOrderData.recipientName || "";
          this.recipientPhone = preOrderData.recipientPhone || "";
          this.recipientAddress = preOrderData.recipientAddress || "";
          this.selectedPeopleCount = preOrderData.peopleCount || "";
          this.selectedItems = preOrderData.selectedItems || [];
          this.activityName = preOrderData.activityName || "";

          console.log("成功加载缓存数据");
        }
      } catch (error) {
        console.error("加载缓存数据失败:", error);
      }
    },

    // 切换预计人数下拉菜单显示状态
    togglePeopleDropdown() {
      this.peopleDropdownVisible = !this.peopleDropdownVisible;
      // 点击人数选择时关闭活动类型下拉菜单
      if (this.dropdownVisible) {
        this.dropdownVisible = false;
      }
    },

    // 选择活动类型
    selectActivityType(type) {
      this.selectedActivityType = type;
      this.dropdownVisible = false;
    },

    // 选择预计人数
    selectPeopleCount(count) {
      this.selectedPeopleCount = count;
      this.peopleDropdownVisible = false;
    },

    // 点击页面其他地方关闭下拉菜单
    handleClickOutside() {
      if (this.dropdownVisible) {
        this.dropdownVisible = false;
      }
      if (this.peopleDropdownVisible) {
        this.peopleDropdownVisible = false;
      }
    },

    // 关闭设备选择器
    handleCloseEquipmentSelector() {
      this.showEquipmentSelector = false;
    },

    // 添加设备到已选列表
    handleAddItem(item) {
      // 检查是否已存在该设备
      const existingItem = this.selectedItems.find(
        (selectedItem) => selectedItem.sku_id === item.sku_id
      );

      if (existingItem) {
        // 如果已存在，则增加数量，使用item中的quantity或默认为1
        existingItem.quantity += item.quantity || 1;
      } else {
        // 如果不存在，则添加新设备，保留item中的quantity属性，如果没有则设置为1
        this.selectedItems.push({
          ...item,
          quantity: item.quantity || 1,
        });
      }

      this.showEquipmentSelector = false;
      // 保存到localStorage
      this.saveToLocalStorage();
    },

    // 保存订单数据到localStorage
    saveToLocalStorage() {
      const preOrderData = {
        recipientName: this.recipientName,
        recipientPhone: this.recipientPhone,
        recipientAddress: this.recipientAddress,
        activityName: this.activityName,
        activityType: this.selectedActivityType,
        startDate: this.startDate,
        endDate: this.endDate,
        location: this.location,
        peopleCount: this.selectedPeopleCount,
        selectedItems: this.selectedItems,
        totalAmount: this.totalAmount.toFixed(2),
      };

      localStorage.setItem("preOrderData", JSON.stringify(preOrderData));
    },

    // 更新设备数量（按索引）
    updateItemQuantity(index, change) {
      const newQuantity = this.selectedItems[index].quantity + change;
      if (newQuantity > 0) {
        this.selectedItems[index].quantity = newQuantity;
        // 保存到localStorage
        this.saveToLocalStorage();
      } else {
        this.removeItem(index);
      }
    },

    // 更新设备数量（按sku_id）
    updateItemQuantityBySku(skuId, change) {
      const index = this.selectedItems.findIndex(
        (item) => item.sku_id === skuId
      );
      if (index !== -1) {
        this.updateItemQuantity(index, change);
      }
    },

    // 移除设备（按索引）
    removeItem(index) {
      this.selectedItems.splice(index, 1);
      // 保存到localStorage
      this.saveToLocalStorage();
    },

    // 移除设备（按sku_id）
    removeItemBySku(skuId) {
      const index = this.selectedItems.findIndex(
        (item) => item.sku_id === skuId
      );
      if (index !== -1) {
        this.removeItem(index);
      }
    },

    // 清空某一分类下的所有设备
    removeAllByCategory(categoryName) {
      this.selectedItems = this.selectedItems.filter((item) => {
        const itemCategory = item.category_name || item.category || "未分类";
        return itemCategory !== categoryName;
      });
      // 保存到localStorage
      this.saveToLocalStorage();
    },

    // 提交预订
    async submitBooking() {
      // 验证表单字段
      const startDate = this.startDate;
      const endDate = this.endDate;
      const location = this.location;

      // 验证必填字段
      if (!this.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }

      if (!this.selectedActivityType) {
        this.$message.warning("请选择活动类型");
        return;
      }

      if (!startDate) {
        this.$message.warning("请选择开始日期");
        return;
      }

      if (!endDate) {
        this.$message.warning("请选择结束日期");
        return;
      }

      if (!location) {
        this.$message.warning("请输入活动地点");
        return;
      }

      if (!this.selectedPeopleCount) {
        this.$message.warning("请选择预计人数");
        return;
      }

      // 验证已选择设备
      if (this.selectedItems.length === 0) {
        this.$message.warning("请至少选择一种租赁设备");
        return;
      }

      // 验证收货人信息
      if (!this.recipientName) {
        this.$message.warning("请输入收货人姓名");
        return;
      }

      if (!this.recipientPhone) {
        this.$message.warning("请输入收货人手机号");
        return;
      }

      if (!this.recipientAddress) {
        this.$message.warning("请输入收货人详细地址");
        return;
      }

      // 构建预订数据
      const preOrderData = {
        activityName: this.activityName,
        activityType: this.selectedActivityType,
        startDate: startDate,
        endDate: endDate,
        location: location,
        peopleCount: this.selectedPeopleCount,
        recipientName: this.recipientName,
        recipientPhone: this.recipientPhone,
        recipientAddress: this.recipientAddress,
        selectedItems: this.selectedItems,
        totalAmount: this.totalAmount.toFixed(2),
      };

      localStorage.setItem("preOrderData", JSON.stringify(preOrderData));

      // api提交到后台
      try {
        const response = await api.order.createPreOrder(preOrderData);
        if (response.data.code === 200) {
          // 清空表单数据
          this.activityName = "";
          this.selectedActivityType = "";
          this.startDate = "";
          this.endDate = "";
          this.location = "";
          this.selectedPeopleCount = "";
          this.recipientName = "";
          this.recipientPhone = "";
          this.recipientAddress = "";
          this.selectedItems = [];
          this.totalAmount = 0;
          // 清空localStorage缓存
          localStorage.removeItem("preOrderData");

          // 跳转到订单详情页
          this.$router.push({
            path: "/ucenter/PreOrderDetail",
            query: {
              orderId: response.data.data.id,
            },
          });
        }
      } catch (error) {
        console.error("预订提交失败:", error);
      }

    },
  },
  mounted() {
    // 从localStorage获取缓存信息
    this.loadCachedData();

    // 监听全局点击事件来关闭下拉菜单
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    // 组件卸载时移除事件监听器，避免内存泄漏
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
/* 容器样式 */
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/PreOrderAdd.vue